import React from 'react';
import { AlertTriangle, Info, XOctagon } from 'lucide-react';

const VARIANT_CONFIG = {
  info: {
    container: 'bg-brand-subtle border-brand-border',
    icon: Info,
    iconClass: 'text-brand-text',
  },
  warning: {
    container: 'bg-status-attention-bg border-(--status-attention)/30',
    icon: AlertTriangle,
    iconClass: 'text-status-attention-text',
  },
  error: {
    container: 'bg-status-negative-bg border-(--status-negative)/30',
    icon: XOctagon,
    iconClass: 'text-status-negative-text',
  },
} as const;

export function AlertBanner({
  title,
  body,
  variant = 'warning',
}: {
  title: string;
  body?: string;
  variant?: 'info' | 'warning' | 'error';
}) {
  const config = VARIANT_CONFIG[variant];
  const Icon = config.icon;

  return (
    <div
      className={`rounded border p-4 flex gap-3 shadow-sm animate-in fade-in slide-in-from-top-1 duration-200 ${config.container}`}
      role="alert"
      aria-label={title}
    >
      <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${config.iconClass}`} />
      <div>
        <h4 className="text-sm font-medium tracking-tight text-foreground">{title}</h4>
        {body && <p className="text-sm text-text-tertiary mt-1.5 leading-[1.7]">{body}</p>}
      </div>
    </div>
  );
}
